var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-card",
    [
      _c(
        "emd-card-header",
        {
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _vm.canShowShop
                    ? _c(
                        "a",
                        {
                          staticClass: "emd-btn _color_primary _size_small",
                          attrs: {
                            id: "link-shop-payment-links",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: _vm.$sanitize(_vm.urlShop),
                          },
                          on: { click: _vm.shopTrack },
                        },
                        [
                          _c("i", { staticClass: "uil uil-plus eu-mr_1" }),
                          _vm._v(" " + _vm._s(_vm.$t("btn-create")) + " "),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("emd-text", [_vm._v(" " + _vm._s(_vm.$t("header")))])],
        1
      ),
      _c(
        "emd-card-content",
        { attrs: { customClass: "emd-table-responsive eu-no-padding" } },
        [
          _c("table-links", {
            attrs: { items: _vm.items, toDetail: _vm.toDetail },
          }),
          _vm.showEmptyListFilter ? _c("empty-list-filter") : _vm._e(),
          _vm.showEmptyList
            ? _c("empty-list", { attrs: { entity: "payment-links" } })
            : _vm._e(),
          _vm.showPagination
            ? _c("pagination", {
                attrs: {
                  type: "list",
                  action: _vm.action,
                  pagination: _vm.pagination,
                  totalShowing: _vm.totalItems,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }